/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable css-modules/no-unused-class */
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Clickable from '../Clickable';
import s from './Gallery.scss';
import Grid from '../Grid';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIx: 0,
    };
  }

  setSelectedIx(selectedIx) {
    this.setState({
      selectedIx,
    });
  }

  render() {
    const { children, rows, onOpen } = this.props;
    const { selectedIx } = this.state;
    const xs = 24 / rows;

    return (
      <Fragment>
        <div className={cx(s.imageContainer)}>
          <Clickable
            onClick={() => onOpen && onOpen(selectedIx)}
            naked
            className={s.clickable}
          >
            {children && children.length >= 1 && children[selectedIx]}
          </Clickable>
        </div>
        <Grid container spacing={8}>
          {children &&
            children.length >= 1 &&
            children.map((child, index) => (
              <Grid
                item
                key={index.toString()}
                xs={xs}
                onClick={() => this.setSelectedIx(index)}
                className={cx(s.thumbnail)}
              >
                {child}
              </Grid>
            ))}
        </Grid>
      </Fragment>
    );
  }
}

Gallery.propTypes = {
  children: PropTypes.node.isRequired,
  rows: PropTypes.number,
  onOpen: PropTypes.func,
};

Gallery.defaultProps = {
  rows: 3,
  onOpen: undefined,
};

export default withStyles(s)(Gallery);
